import { createContext, useContext } from 'react';
import { DemographicInsightPresentationMode } from 'modules/domains/segmentation';
import { ContactProperty } from 'modules/domains/user';
import noop from 'utils/noop';
import { CustomDemographicInsight } from '../../types';

export type CustomDemographic = {
  addDemographicContactProperty: (
    contactProperty: string,
    mode: DemographicInsightPresentationMode,
  ) => void;
  deleteDemographicContactProperty: (contactProperty: string) => void;
  cachedCustomDemograhpicInsights: CustomDemographicInsight[];
  contactProperties: ContactProperty[];
  maxDemographicInsightSettingsForProject: number;
  isCustomDemographicInsightLoading: boolean;
};

export const customDemographicDefaultState: CustomDemographic = {
  addDemographicContactProperty: noop,
  deleteDemographicContactProperty: noop,
  cachedCustomDemograhpicInsights: [],
  contactProperties: [],
  maxDemographicInsightSettingsForProject: 0,
  isCustomDemographicInsightLoading: false,
};

export const CustomDemographicContext = createContext<CustomDemographic>(
  customDemographicDefaultState,
);
export const useCustomDemographicContext = () => useContext(CustomDemographicContext);
